// =============================================================================
// src/data/manaus-markers.ts — Marcadores de mapa (CNPJ + eventos ao vivo).
//
// Proveniencia: assets/unified-app.js DATA.cnpjMarkers (negocios, linhas 250-259)
//   e DATA.liveMarkers (monitoramento, linhas 262-271). Portado verbatim.
//   Os marcadores `pulse:true` recebem o anel animado .u-marker-pulse no render.
// =============================================================================

import type { CnpjMarker, LiveMarker } from '../app/types';

/** Marcadores de CNPJ da secao Negocios (DATA.cnpjMarkers). */
export const MANAUS_CNPJ_MARKERS: readonly CnpjMarker[] = [
  { lat: -3.08, lng: -60.05, type: 'ind', size: 'major', color: '#185FA5', label: 'Indústria Norte · R$ 4,2 bi', icon: 'ti-building-factory-2' },
  { lat: -3.10, lng: -60.02, type: 'com', size: 'major', color: '#1D9E75', label: 'Bemar · R$ 1,8 bi', icon: 'ti-building-store' },
  { lat: -3.12, lng: -59.98, type: 'con', size: 'major', color: '#639922', label: 'Constr. Amazonas · R$ 980 mi', icon: 'ti-building-skyscraper' },
  { lat: -3.06, lng: -60.06, type: 'ene', size: 'major', color: '#EF9F27', label: 'Energia Cidade · R$ 780 mi', icon: 'ti-bolt' },
  { lat: -3.07, lng: -60.01, type: 'ind', size: 'cluster', color: '#185FA5', count: 18 },
  { lat: -3.08, lng: -59.95, type: 'ind', size: 'cluster', color: '#185FA5', count: 12 },
  { lat: -3.11, lng: -60.05, type: 'com', size: 'cluster', color: '#1D9E75', count: 34 },
  { lat: -3.13, lng: -60.03, type: 'svc', size: 'cluster', color: '#7F77DD', count: 27 },
];

/** Marcadores de eventos ao vivo da secao Monitoramento (DATA.liveMarkers). */
export const MANAUS_LIVE_MARKERS: readonly LiveMarker[] = [
  { lat: -3.06, lng: -60.04, type: 'crit', color: '#E24B4A', icon: 'ti-alert-triangle', badge: 3, pulse: true },
  { lat: -3.07, lng: -60.05, type: 'warn', color: '#EF9F27', icon: 'ti-news', pulse: true },
  { lat: -3.13, lng: -60.06, type: 'crit', color: '#E24B4A', icon: 'ti-clock-x', badge: 5, pulse: true },
  { lat: -3.09, lng: -59.96, type: 'sec', color: '#7F77DD', icon: 'ti-shield', pulse: false },
  { lat: -3.11, lng: -60.00, type: 'event', color: '#1D9E75', icon: 'ti-microphone-2', pulse: false },
  { lat: -3.12, lng: -59.97, type: 'poll', color: '#378ADD', icon: 'ti-chart-bar', badge: 4, pulse: false },
  { lat: -3.11, lng: -60.04, type: 'warn', color: '#EF9F27', icon: 'ti-bolt', pulse: true },
  { lat: -3.10, lng: -59.97, type: 'event', color: '#1D9E75', icon: 'ti-confetti', pulse: false },
];
